import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCode(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M15.895 6.447a1 1 0 1 0-1.79-.894l-6 12a1 1 0 0 0 1.79.894l6-12ZM6.707 15.707a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L4.414 12l2.293 2.293a1 1 0 0 1 0 1.414ZM17.293 8.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L19.586 12l-2.293-2.293a1 1 0 0 1 0-1.414Z"
      />
    </BaseIcon>
  );
}
